import { css } from 'lit';

export const facet1OnDarkStyles = css`
  --_facet-1__aspect-ratio--mobile: 1;
  --_facet-1__width--mobile: var(--_image__facet-1__width);
  --_facet-1__margin--mobile: var(--_image__facet-1__margin);

  --_facet-1-md__display--md: none;
  --_facet-1-lg__display--lg: none;

  --_facet-1__onDark: block;
  --_facet-1-lg__display--lg: none;

  --_facet-1__clip-path--mobile: polygon( 99.25% 30.025%,99.25% 75.6%,67.675% 93.825%,67.675% 93.825%,66.18% 94.588%,64.63% 95.181%,63.039% 95.605%,61.42% 95.859%,59.788% 95.944%,58.155% 95.859%,56.536% 95.605%,54.945% 95.181%,53.395% 94.588%,51.9% 93.825%,20.325% 75.6%,20.325% 75.6%,16.802% 73.311%,13.579% 70.692%,10.673% 67.774%,8.101% 64.586%,5.878% 61.156%,4.022% 57.515%,2.55% 53.692%,1.478% 49.717%,0.822% 45.618%,0.6% 41.425%,0.6% 41.425%,0.6% 41.425%,0.822% 37.232%,1.478% 33.133%,2.55% 29.158%,4.022% 25.335%,5.878% 21.694%,8.101% 18.264%,10.673% 15.076%,13.579% 12.158%,16.802% 9.539%,20.325% 7.25%,20.325% 7.25%,20.325% 7.25%,24.065% 5.347%,27.942% 3.866%,31.921% 2.809%,35.97% 2.174%,40.053% 1.963%,44.137% 2.174%,48.188% 2.809%,52.171% 3.866%,56.053% 5.347%,59.8% 7.25%,99.25% 30.025% );

  --_facet-1__onDark--xl: block;
`;
